<template>
  <!-- CPAP 預託機申込み -->
  <div id="CpapInstrumentRequest">
    <section>
      <div id="container-center">
        <form>
        <h1 style="" class="title has-text-centered printTarget">CPAP 預託機申込み</h1>
        <div>
          <b-steps v-model="activeStep" :animated="true" :rounded="true" :has-navigation="false" label-position="bottom">
            <b-step-item step="1" label="医療機関情報" icon="clipboard-edit-outline">
              <div id="item-contens">
                <div class="request-title">
                  <b-button v-if="false" class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">戻る</b-button>
                  <b-button v-else class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面 </b-button>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" :disabled="!isHospitalAgree" @click.prevent="Forward">次へ</b-button>
                  <span>申込み内容を入力してください。</span>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <tr v-if="false"><th>保管先<span class="require"/></th>
                      <td>
                        <div>
                          <b-radio class="td_radio" :native-value="true">ディーラー</b-radio>
                          <b-radio class="td_radio" :native-value="false">医療機関</b-radio>
                        </div>
                      </td>
                    </tr>
                    <tr><th>医療機関名<span class="require" v-if="isDealer || isHonsha || isAdmin || isSalesOffice"/></th>
                      <td>
                        <template v-if="isDealer || isHonsha || isAdmin || isSalesOffice">
                          <input type="text" style="width:730px;" v-model="reqParams.hospitalName" class="2" name="医療機関名" validate="required" disabled />
                          <b-button style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">医療機関選択</b-button>
                        </template>
                        <template v-else>{{reqParams.hospitalName}}</template>
                      </td>
                    </tr>
                    <tr><th>医師名<span class="require"/></th><td><input type="text" v-model="reqParams.doctorName" maxlength="105"/></td></tr>
                    <tr><th>事務担当者名</th><td><input type="text"  v-model="reqParams.clerkName" maxlength="100"/></td></tr>
                    <template v-if="isDealer">
                      <tr><th>医療機関メールアドレス</th><td><b-checkbox class="cstmCheckBox" v-model="reqParams.mailNotification">申込み内容を医療機関にメールで通知する。</b-checkbox></td></tr>
                      <tr v-if="reqParams.mailNotification"><th></th><td><input type="text" v-model="reqParams.hospitalMail" maxlength="256" placeholder="例）example@example.com" class="2" name="医療機関メールアドレス" validate="mail|required"></td></tr>
                    </template>
                    <tr><th>機種<span class="require" name="item_step2" id="model"/></th><td><select id="model" class="2" name="機種" validate="required" @change="changeModel" v-model="reqParams.model"><option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option></select></td></tr>
                    <tr><th>台数<span class="require"/></th><td><input style="width:250px;" type="text" maxlength="5"/>台</td></tr>
                    <tr>
                      <th>加温加湿器<span class="require"/></th>
                      <td>
                        <div>
                          <b-radio class="td_radio" :native-value="true">あり</b-radio>
                          <b-radio class="td_radio" :native-value="false">なし</b-radio>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>通信モジュール<span class="require"/></th>
                      <td>
                        <div>
                          <b-radio class="td_radio" :native-value="true">あり</b-radio>
                          <b-radio class="td_radio" :native-value="false">なし</b-radio>
                        </div>
                      </td>
                    </tr>
                    <tr><th>【マスク】</th></tr>
                    <tr><th>個数<span class="require"/></th><td><input type="text" maxlength="256" /></td></tr>
                    <tr><th>種類<span class="require"/></th><td><select /></td></tr>
                    <tr><th>フレームサイズ<span class="require"/></th><td><select /></td></tr>
                    <tr><th>クッションサイズ<span class="require"/></th><td><select /></td></tr>
                    
                    <tr><th>【機器納品先】</th></tr>
                    <tr>
                      <th>郵便番号<span class="require" /></th>
                      <td>
                        <input
                          style="width: 270px"
                          v-model="reqParams.zip"
                          class="2"
                          :class="{'border-red': invalidDeviceDestPostcode}"
                          name="機器納品先の郵便番号"
                          validate="required|numeric"
                          maxlength="7"
                          :placeholder="postcodePlaceholder"
                        /><b-button
                          style="margin-left: 10px; width: 150px; height: 27px"
                          v-on:click="addressSearch('device', reqParams.zip)"
                          >郵便番号検索</b-button
                        >
                        <div v-show="invalidDeviceDestPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                      </td>
                    </tr>
                    <tr><th>住所<span class="require"/></th><td><input type="text" v-model="reqParams.address" class="2" name="機器納品先の住所" validate="required" maxlength="280"/></td></tr>
                    <tr><th>住所（丁目、番地）<span class="require"/></th><td><input type="text" v-model="reqParams.address1" class="2" name="機器納品先の住所（丁目、番地）" validate="required" maxlength="256"/></td></tr>
                    <tr><th>住所（建物名、号室）</th><td><input type="text" v-model="reqParams.address2" maxlength="256"/></td></tr>
                    <tr><th>宛名<span class="require"/></th><td><input type="text" v-model="reqParams.receiverName" maxlength="100" class="2" name="機器納品先の宛名" validate="required"/></td></tr>
                    <tr>
                      <th>連絡先(電話番号)<span class="require" /></th>
                      <td>
                        <input
                          type="text"
                          v-model="reqParams.phoneNumber"
                          maxlength="11"
                          class="2"
                          :class="{'border-red': invalidDeviceDestPhoneNumber}"
                          name="機器納品先の連絡先(電話番号)"
                          validate="required|numeric"
                          :placeholder="phonePlaceholder"
                        />
                        <div v-show="invalidDeviceDestPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                      </td>
                    </tr>
                    <tr v-if="false"><th>配達希望時間帯</th><td><select v-model="reqParams.desiredDeliveryTimeZone" ><option v-for="timeZone in desiredDeliveryTimeZoneList" :value="timeZone.value" :key="timeZone.value">{{ timeZone.label1 }}</option></select></td></tr>
                    <template v-if="false">
                      <tr><th>【結果送付先】</th></tr>
                      <tr>
                        <th>郵便番号<span class="require" /></th>
                        <td>
                          <input
                            style="width: 270px"
                            v-model="reqParams.resultZip"
                            maxlength="7"
                            class="2"
                            :class="{'border-red': invalidResultDestPostcode}"
                            name="結果送付先の郵便番号"
                            validate="required|numeric"
                            :placeholder="postcodePlaceholder"
                          /><b-button
                            style="margin-left: 10px; width: 150px; height: 27px"
                            v-on:click="addressSearch('result', reqParams.resultZip)"
                            >郵便番号検索</b-button
                          >
                          <div v-show="invalidResultDestPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                        </td>
                      </tr>
                      <tr><th>住所<span class="require"/></th><td><input type="text" v-model="reqParams.resultAddress" maxlength="280" class="2" name="結果送付先の住所" validate="required"/></td></tr>
                      <tr><th>建物名</th><td><input type="text" v-model="reqParams.resultBuildingName" maxlength="256"/></td></tr>
                      <tr><th>医療機関名(会社名)</th><td><input type="text" placeholder="宛名を個人宛にする場合、医療機関名(会社名）はこちらに入力してください。" v-model="reqParams.resultCompanyName" maxlength="256"/></td></tr>
                      <tr><th>診療科(部署名)</th><td><input type="text" placeholder="宛名を個人宛にする場合、診療科(部署名）はこちらに入力してください。" v-model="reqParams.resultDivision" maxlength="100"/></td></tr>
                      <tr><th>宛名<span class="require"/></th><td><input type="text" placeholder="宛名に医療機関(会社名)を入れる場合、「医療機関名(会社名)」「診療科(部署名)」欄は空欄にしてください。" v-model="reqParams.resultReceiverName" maxlength="100" class="2" name="結果送付先の宛名" validate="required"/></td></tr>
                      <tr>
                        <th>連絡先(電話番号)<span class="require" /></th>
                        <td>
                          <input
                            type="text"
                            v-model="reqParams.resultPhoneNumber"
                            maxlength="11"
                            class="2"
                            :class="{'border-red': invalidResultDestPhoneNumber}"
                            name="結果送付先の連絡先(電話番号)"
                            validate="required|numeric"
                            :placeholder="phonePlaceholder"
                          />
                          <div v-show="invalidResultDestPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                        </td>
                      </tr>
                    </template>
                    <tr v-if="false"><th class="deliverySlip_label">納品書</th>
                      <td>
                        <div>
                          <b-radio class="td_radio deliverySlip_radio" name="deliverySlip" v-model="reqParams.deliverySlip" :native-value="true">必要</b-radio>
                          <b-radio class="td_radio deliverySlip_radio" name="deliverySlip" v-model="reqParams.deliverySlip" :native-value="false">不要</b-radio>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="false"><th>試用</th><td><b-checkbox v-model="reqParams.demo" class="cstmCheckBox">デモ(トライアル)</b-checkbox></td></tr>
                    <template v-if="isDealer">
                      <tr/>
                      <tr>
                        <th/><td><b-checkbox class="cstmCheckBox" v-model="isHospitalAgree">申請者がCPAPの申込みを行うことについて、該当医療機関の同意を取得しています。</b-checkbox></td>
                      </tr>
                    </template>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="3" label="患者情報" icon="account" v-if="false">
              <div id="item-contens" v-bind:key="renderKey">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left"  @click.prevent="Backward">前へ</b-button>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                  <span>患者の情報を入力してください。</span>
                </div>
                <template v-for="(patient, index) in reqParams.patientsData">
                  <div class="card-content margin-top" :key="index">
                    <table>
                      <!--
                      <tr v-if="index > 0">
                        <td colspan="2">
                          <b-button style="float:right; width:27px; height:27px; border:none;" icon-left="close-box-outline" @click="deletePatient(index)"></b-button>
                        </td>
                      </tr>
                      -->
                      <tr><th>診察券ID（患者ID）<span class="require" /></th><td><input type="text" v-model="patient.patientId" maxlength="50" class="3" :name="index+1+'番目、診察券ID（患者ID）'" validate="required" /></td></tr>
                      <tr><th>患者名<span class="require" /></th><td><input type="text" style="margin-right: 5px; width: 446px !important;" placeholder="姓" v-model="patient.patientFamilyName" class="3" :name="index+1+'番目、患者名(姓)'" validate="required" maxlength="49"/><input type="text" style="width: 446px !important;" placeholder="名" v-model="patient.patientFirstName" class="3" :name="index+1+'番目、患者名(名)'" validate="required" maxlength="49" @blur="focusLostPatientFirstName(index)"/></td></tr>
                      <tr><th>患者名（カナ）<span class="require" /></th><td><input type="text" style="margin-right: 5px; width: 446px !important;" placeholder="セイ" v-model="patient.patientFamilyNameKana" class="3" :name="index+1+'番目、患者名カナ(セイ)'" validate="kana|required" maxlength="49"/><input type="text" style="width: 446px !important;" placeholder="メイ" v-model="patient.patientFirstNameKana" class="3" :name="index+1+'番目、患者名カナ(メイ)'" validate="kana|required" maxlength="49"/></td></tr>
                      <tr><th>性別<span class="require" /></th><td>
                        <div class="block">
                          <b-radio size="is-small" v-model="patient.gender" native-value="-">-</b-radio>
                          <b-radio size="is-small" v-model="patient.gender" native-value="男">男</b-radio>
                          <b-radio size="is-small" v-model="patient.gender" native-value="女">女</b-radio>
                        </div></td>
                      </tr>
                      <tr><th>生年月日<span class="require"/></th><td><input type="date" v-model="patient.birthday" :input="inputBirthday(patient.birthday,index)" class="3" :name="index+1+'番目、患者の生年月日'" validate="required|date|birthDay" :max="yyyy_hyp_MM_hyp_dd(new Date())" style="width:150px;"/><span v-if="patient.birthday" style="margin-left:10px;">{{patient.japaneseCalendar}}</span></td></tr>
                      <tr><th>年齢</th><td><input type="text" disabled v-model="patient.age"/></td></tr>
                      <tr>
                        <th>郵便番号<span class="require" /></th>
                        <td>
                          <input
                            v-model="patient.zip"
                            type="text"
                            maxlength="7"
                            style="width: 270px"
                            class="3"
                            :class="{'border-red': patient.invalidPostcode}"
                            :name="index + 1 + '番目、患者の郵便番号'"
                            validate="required|numeric"
                            :placeholder="postcodePlaceholder"
                          /><b-button
                            style="margin-left: 10px; width: 150px; height: 27px"
                            v-on:click="patientAddressSearch(index, patient.zip)"
                            >郵便番号検索</b-button
                          >
                          <div v-show="patient.invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                        </td>
                      </tr>
                      <tr><th>住所<span class="require"/></th><td><input type="text" v-model="patient.address" maxlength="256" class="3" :name="index+1+'番目、患者の住所'" validate="required"/></td></tr>
                      <tr><th>住所（丁目、番地）<span class="require"/></th><td><input type="text" v-model="patient.address1" maxlength="256" class="3" :name="index+1+'番目、患者の住所（丁目、番地）'" validate="required"/></td></tr>
                      <tr><th>住所（建物名、号室）</th><td><input type="text" v-model="patient.address2" maxlength="256"/></td></tr>
                      <tr><th>宛名<span class="require"/></th><td><input type="text" v-model="patient.receiverName" maxlength="100" class="3" :name="index+1+'番目、患者の宛名'" validate="required"/></td></tr>
                      <tr>
                        <th>連絡先（自宅または携帯）<span class="require" /></th>
                        <td>
                          <input
                            type="text"
                            v-model="patient.phoneNumber"
                            maxlength="11"
                            class="3"
                            :class="{'border-red': patient.invalidPhoneNumber}"
                            :name="index + 1 + '番目、患者の連絡先（自宅または携帯）'"
                            validate="required|numeric"
                            :placeholder="phonePlaceholder"
                          />
                          <div v-show="patient.invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                        </td>
                      </tr>
                      <tr><th>フォローアップコール</th>
                        <td>
                          <div>
                            <b-radio class="td_radio" name="followUpCall" :native-value="true">する</b-radio>
                            <b-radio class="td_radio" name="followUpCall" :native-value="false">しない</b-radio>
                          </div>
                        </td>
                      </tr>
                      <tr><th>病名</th>
                        <td>
                          <input type="text" v-model="patient.disease" maxlength="256" class="3" :name="index+1+'番目、患者の病名'" validate="required"/>
                        </td>
                      </tr>
                      <tr><th>感染症名</th><td><input type="text" v-model="patient.infectionName" maxlength="256" class="3" :name="index+1+'番目、病名'"/></td></tr>
                      <tr><th>地域医療連携施設名</th><td><input type="text" v-model="patient.hospitalName" maxlength="256" /></td></tr>
                      <tr><th>地域医療連携施設　医師名</th><td><input type="text" v-model="patient.doctorName" maxlength="105"/></td></tr>
                      
                      <tr v-if="false"><th>配達希望時間帯</th><td><select v-model="patient.desiredDeliveryTimeZone" ><option v-for="timeZone in desiredDeliveryTimeZoneList" :value="timeZone.value" :key="timeZone.value">{{ timeZone.label1 }}</option></select></td></tr>
                      <tr><th>備考、その他、注意事項</th><td><textarea v-model="patient.memo" maxlength="256" style="resize:vertical;max-width:100%;"></textarea></td>
                      </tr>
                    </table>
                  </div>
                </template>
                <!--
                <div class="card-content margin-top">
                    <table>
                      <tr>
                        <th style="vertical-align:top;">注意事項</th>
                        <td>出荷日は「配送情報」で設定します。なお患者情報を複数人設定した場合でも出荷日は同一日となります。</td>
                      </tr>
                    </table>
                </div>
                
                <div class="margin-top">
                  <b-button style="width:100%;background:#6191eb; color:black;" @click="addPatient" >患者を追加する</b-button>
                </div>
                -->
              </div>
            </b-step-item>
            <b-step-item step="4" label="装置情報" icon="clipboard-pulse-outline" v-if="false">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>装置情報を入力してください。</span>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <tr><th>モード<span class="require"/></th><td><select><option></option><option>AutoCPAPモード</option><option>CPAPモード</option></select></td></tr>
                    <tr v-if="false" ><th>返却日</th><td>{{reqParams.returnDate}}</td></tr>
                    <tr><th>S/N<span class="require"/></th><td><input type="text" placeholder="" maxlength="100" name="S/N" validate="required"/></td></tr>
                    <tr><th>EZ-Start</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>CPAP圧</th><td><input type="text" placeholder="" maxlength="100" name="最大圧"/></td></tr>
                    <tr><th>Flexタイプ</th><td><select><option></option><option>C-Flex</option><option>C-Flex+</option><option>0（オフ）</option></select></td></tr>
                    
                    <!-- add -->
                    <tr><th>APAP</th><td><select><option></option><option>OFF</option><option>1</option><option>2</option><option>3</option></select></td></tr>
                    
                    <tr><th>softPAP</th><td><select><option></option><option>標準</option><option>動的</option></select></td></tr>
                    <tr><th>softPAPロック</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>CC+</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>CC+機能有効時間 ランプのみ</th><td><select><option></option><option>R1</option><option>R2</option><option>R3</option></select></td></tr>
                    <tr><th>CC+機能有効時間 全治療時間</th><td><select><option></option><option>1</option><option>2</option><option>3</option></select></td></tr>
                    <!--
                    <tr><th>Opti-Start</th><td></td></tr>
                    <tr><th>最大圧</th><td></td></tr>
                    <tr><th>最小圧</th><td></tr>
                    <tr><th>Flexタイプ</th><td></td></tr>
                    <tr><th>CC+</th><td></td></tr>
                    <tr><th>CC+機能有効時間 ランプのみ</th><td></td></tr>
                    <tr><th>CC+機能有効時間 全治療時間</th><td></td></tr>
                    <tr><th>APAP</th><td></td></tr>
                    <tr><th>softPAP</th><td></td></tr>
                    <tr><th>softPAPロック</th><td></td></tr>
                    -->
                    <tr><th>IPAP</th><td><input type="text" placeholder="" maxlength="100" name="IPAP"/></td></tr>
                    <tr><th>EPAP</th><td><input type="text" placeholder="" maxlength="100" name="EPAP"/></td></tr>
                    <!--
                    <tr><th>IPAP圧</th><td></td></tr>
                    <tr><th>EPAP圧</th><td></td></tr>
                    <tr><th>TRILevel</th><td></td></tr>
                    <tr><th>IPAP最大圧</th><td></td></tr>
                    <tr><th>EPAP最小圧</th><td></td></tr>
                    -->
                    <tr><th>PS最大圧</th><td><input type="text" placeholder="" maxlength="100" name="PS最大圧"/></td></tr>
                    <tr><th>PS最小圧</th><td><input type="text" placeholder="" maxlength="100" name="PS最小圧"/></td></tr>
                    <tr><th>EEPAP max 圧</th><td><input type="text" placeholder="" maxlength="100" name="EEPAP max 圧"/></td></tr>
                    <tr><th>EEPAP min 圧</th><td><input type="text" placeholder="" maxlength="100" name="EEPAP min 圧"/></td></tr>
                    <tr><th>PDIFF max 圧</th><td><input type="text" placeholder="" maxlength="100" name="PDIFF max 圧"/></td></tr>
                    <tr><th>PDIFF norm 圧</th><td><input type="text" placeholder="" maxlength="100" name="PDIFF norm 圧"/></td></tr>
                    <tr><th>PDIFF min 圧</th><td><input type="text" placeholder="" maxlength="100" name="PDIFF min 圧"/></td></tr>
                    <tr><th>IPAP max 圧</th><td><input type="text" placeholder="" maxlength="100" name="IPAP max 圧"/></td></tr>
                    <tr><th>IPAP min 圧</th><td><input type="text" placeholder="" maxlength="100" name="IPAP min 圧"/></td></tr>
                    <tr><th>TRILevel</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>Opti-Start</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>最大圧</th><td><input type="text" placeholder="" maxlength="100" name="最大圧"/></td></tr>

                    <!-- add -->
                    <tr><th>最小圧</th><td><input type="text" placeholder="" maxlength="100" name="最小圧"/></td></tr>

                    <tr><th>EPAP最大圧</th><td><input type="text" placeholder="" maxlength="100" name="EPAP最大圧"/></td></tr>
                    <tr><th>EPAP最小圧</th><td><input type="text" placeholder="" maxlength="100" name="EPAP最小圧"/></td></tr>
                    <tr><th>PS最大圧</th><td><input type="text" placeholder="" maxlength="100" name="PS最大圧"/></td></tr>
                    <tr><th>PS最小圧</th><td><input type="text" placeholder="" maxlength="100" name="PS最小圧"/></td></tr>
                    <tr><th>BPM(バックアップ呼吸回数)</th><td><input type="text" placeholder="" maxlength="100" name="BPM(バックアップ呼吸回数)"/></td></tr>
                    <tr><th>吸気時間</th><td><input type="text" placeholder="" maxlength="100" name="IPAP"/></td></tr>
                    <!--
                    <tr><th>EEPAP max 圧</th><td></td></tr>
                    <tr><th>EEPAP min 圧</th><td></td></tr>
                    <tr><th>PDIFF 圧  max</th><td></td></tr>
                    <tr><th>PDIFF圧 norm</th><td></td></tr>
                    <tr><th>IPAP max 圧</th><td></td></tr>
                    <tr><th>TRILevel</th><td></td></tr>
                    -->
                    <tr><th>autoF</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>F min</th><td><input type="text" placeholder="" maxlength="100" name="F min"/></td></tr>
                    <tr><th>Ti/T設定</th><td><input type="text" placeholder="" maxlength="100" name="Ti/T設定"/></td></tr>
                    <tr><th>SmartRamp機能</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>ランプ時間</th><td><input type="text" placeholder="" maxlength="100" name="ランプ時間"/>分</td></tr>
                    <tr><th>ランプスタート圧</th><td><input type="text" placeholder="" maxlength="100" name="ランプスタート圧"/></td></tr>
                    <tr><th>Flexタイプ</th><td><select><option></option><option>B-Flex</option><option>C-Flex</option><option>C-Flex+</option><option>0（オフ）</option></select></td></tr>
                    <tr><th>Flex設定</th><td><select><option></option><option>1</option><option>2</option><option>3</option></select></td></tr>
                    <!--
                    <tr><th>Flexタイプ</th><td></td></tr>
                    -->
                    <tr><th>Bi-Filex</th><td><select><option></option><option>1</option><option>2</option><option>3</option></select></td></tr>
                    <tr><th>Flex設定ロック</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>呼吸回路タイプ</th><td><select><option></option><option>12</option><option>15</option><option>15H</option><option>22</option></select></td></tr>
                    <tr><th>呼吸回路タイプロック</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>マスクタイプ</th><td><select><option></option><option>0</option><option>X1</option><option>X2</option><option>X3</option><option>X4</option><option>X5</option></select></td></tr>
                    <tr><th>マスクタイプロック</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>マスクフィットチェック</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>AHI/Fit/PBの表示</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>hPa/cmH2O</th><td><select><option></option><option>hPa</option><option>cmH2O</option></select></td></tr>
                    <!-- add -->
                    <tr><th>オート</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <!-- delete
                    <tr><th>オートON</th><td></td></tr>
                    <tr><th>オートOFF</th><td></td></tr>
                    -->
                    <tr><th>ライズタイム</th><td><select><option></option><option>0</option><option>1</option><option>2</option><option>3</option><option>4</option><option>5</option><option>6</option></select></td></tr>
                    <tr><th>ライズタイムロック</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>言語設定</th><td><select><option></option><option>JP</option><option>EN</option></select></td></tr>
                    <tr><th>接続外れアラート</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>重度のリークアラート</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>アラーム音量</th><td><select><option></option><option>1</option><option>2</option><option>3</option></select></td></tr>
                    <tr><th>リークアラートロック</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>autoSTART-STOP</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>マスクテスト圧力</th><td><input type="text" placeholder="" maxlength="100" name="マスクテスト圧力"/></td></tr>
                    <tr><th>softSTART圧力</th><td><input type="text" placeholder="" maxlength="100" name="softSTART圧力"/></td></tr>
                    <tr><th>softSTART</th><td><input type="text" placeholder="" maxlength="100" name="softSTART"/></td></tr>
                    <tr><th>チューブタイプ</th><td><select><option></option><option>22</option><option>15</option></select></td></tr>
                    <tr><th>チューブタイプロック</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>圧力単位</th><td><select><option></option><option>hPa</option><option>mBar</option><option>cmH2O</option></select></td></tr>
                    <tr><th>ランプ機能</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>ランプタイプ</th><td><select><option></option><option>T.RAMP</option><option>I.RAMP</option></select></td></tr>
                    <tr><th>ランプ時間</th><td><input type="text" placeholder="" maxlength="100" name="ランプ時間"/></td></tr>
                    <tr><th>ランプ開始圧</th><td><input type="text" placeholder="" maxlength="100" name="ランプ開始圧"/></td></tr>
                    <tr><th>hPa/cmH2O</th><td><select><option></option><option>hPa</option><option>cmH2O</option></select></td></tr>
                    <tr><th>インテリジェントスタート</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr><th>呼吸回路タイプ</th><td><select><option></option><option>15</option><option>15H</option><option>22</option><option>22H</option></select></td></tr>
                    <tr><th>マスクタイプ</th><td><select><option></option><option>A</option><option>B</option><option>C</option><option>その他</option></select></td></tr>
                    <tr><th>マスクタイプ(入力値）</th><td><input type="text" placeholder="" maxlength="100" name="ランプ時間"/></td></tr>
                    <tr><th>患者パラメータのアクセス</th><td><select><option></option><option>LOCK</option><option>UNLOCK</option></select></td></tr>
                    <tr><th>呼吸回路外れアラーム</th><td><select><option></option><option>0</option><option>15</option><option>60</option></select></td></tr>
                    <tr><th>無呼吸アラーム</th><td><select><option></option><option>0</option><option>10</option><option>20</option><option>30</option><option>40</option></select></td></tr>
                    <tr><th>分時換気量加減アラーム</th><td><input type="text" placeholder="" maxlength="100" name="分時換気量加減アラーム"/></td></tr>
                    <tr><th>AHI/leak/PBの表示</th><td><select><option></option><option>ON</option><option>OFF</option></select></td></tr>
                    <tr>
                      <th>注意事項</th>
                      <td>
                        <textarea v-model="reqParams.memo" maxlength="256" style="resize:vertical;max-width:100%;"></textarea>
                        <!--
                        <br/><span style="font-size: 14px;">※大変申し訳ございませんが、着日指定のコメントを記載いただいても、対応できかねますので、予めご了承ください。</span>
                        -->
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="5" label="関連用品" icon="clipboard-check-outline" v-if="false">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>関連用品を入力してください。</span>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <tr><th>加温加湿器</th><td><select><option></option><option>無</option><option>有</option></select></td></tr>
                    <tr><th>設置日</th><td><input type="date" validate="date" :min="yyyy_hyp_MM_hyp_dd(new Date())" style="width:150px;"/></td></tr>
                    <tr><th>S/N</th><td><input type="text" placeholder="" maxlength="100" name="ランプ開始圧"/></td></tr>
                    <tr><th>機種</th><td>ドリームステーション用加温加湿器</td></tr>
                    <tr><th>加湿モード</th><td><select><option></option><option>標準</option><option>アドバンス</option><option>ヒーターチューブ式加温加湿</option></select></td></tr>
                    <tr><th>加湿器設定/加湿器レベル</th><td><select><option></option><option>OFF</option><option>1</option><option>2</option><option>3</option><option>4</option><option>5</option><option>6</option><option>7</option><option>8</option><option>9</option><option>10</option></select></td></tr>
                    <tr><th>加湿器最大レベル</th><td><select><option></option><option>1</option><option>2</option><option>3</option><option>4</option><option>5</option><option>6</option><option>7</option></select></td></tr>
                    <tr><th>回路温度設定（※ヒーターチューブ温度asv）</th><td><input type="text" placeholder="" maxlength="100" name="回路温度設定"/></td></tr>
                    <tr><th>加湿回路設定</th><td><select><option></option><option>OFF</option><option>AUTO</option><option>1</option><option>2</option><option>3</option><option>4</option><option>5</option></select></td></tr>
                    <tr><th>通信モジュール</th><td><select><option></option><option>無</option><option>有</option></select></td></tr>
                    <tr><th>設置日</th><td><input type="date" validate="date" :min="yyyy_hyp_MM_hyp_dd(new Date())" style="width:150px;"/></td></tr>
                    <tr><th>S/N</th><td><input type="text" placeholder="" maxlength="100" name="通信モジュールのS/N"/></td></tr>
                    <tr><th>患者情報管理</th><td><select><option></option><option>ケアオーケストレーター</option><option>アンコールエニウェア</option></select></td></tr>
                    <tr><th>モバイルアプリ<span style="font-size: 10px;">（ドリームマッパー）</span></th><td><select><option></option><option>使用する</option><option>使用しない</option></select></td></tr>
                    <tr><th>メールアドレス</th><td><input type="text" maxlength="256" placeholder="例）example@example.com" name="メールアドレス" validate="mail"/></td></tr>
                    <tr><th>登録方法</th><td><select><option></option><option>フィリップス・ジャパンにて登録</option><option>医療施設にて登録</option><option>登録しない</option></select></td></tr>
                    <tr><th>マスク：種類</th><td><select><option></option></select></td></tr>
                    <tr><th>マスク：フレームサイズ</th><td><select><option></option></select></td></tr>
                    <tr><th>マスク：クッションサイズ</th><td><select><option></option></select></td></tr>
                    <tr><th>マスク：固定方法</th><td><select><option></option></select></td></tr>
                    <tr><th>使用回路</th><td><select><option></option><option>12mm</option><option>15mm</option><option>22mm</option><option>ヒーテッドチューブ</option></select></td></tr>
                    <tr>
                      <th>注意事項</th>
                      <td>
                        <textarea maxlength="256" style="resize:vertical;max-width:100%;"></textarea>
                        <!--
                        <br/><span style="font-size: 14px;">※大変申し訳ございませんが、着日指定のコメントを記載いただいても、対応できかねますので、予めご了承ください。</span>
                        -->
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="2" label="申込み" icon="cloud-upload">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward" >前へ</b-button>
                  <span>以下の申込み内容を確認のうえ、下部の「申込みを完了する」ボタンを押下してください。</span>
                </div>
                <!--　申込み詳細 -->
                <cpapRequestDetail :data="showDetailTargetData" :showRequestMemo="false"/>
                <div class="card-content margin-top">
                  <span style="font-size:20px;">その他</span>
                  <table>
                    <tr>
                      <th>備考</th>
                      <td>
                        <textarea maxlength="256" style="resize:vertical;max-width:100%;height:120px"></textarea>
                      </td>
                    </tr>
                    <tr><th></th><td><span style="font-size: 14px;">※伝達事項がございましたらご記入ください。</span></td></tr>
                  </table>
                </div>
                <b-button class="is-primary" style="margin-top:5px;width:250px;" @click="requestHst">申込みを完了する</b-button>
              </div>
            </b-step-item>
            <b-step-item step="3" label="完了" icon="check" :type="{'is-success': true}">
              <section class="unPrintTarget">
                <div class="request-title"><span>預託機の申込みを受け付けました。</span></div>
                <div class="request-title" v-if="needAgree"><span style="color:red;">翌営業日までに登録済みメールアドレスへ申し込み完了メールが送信されます。</span></div>
                <div class="margin-top">
                  <b-button class="backbutton is-primary" @click="back">戻る</b-button>
                  <b-button class="printbutton is-primary" icon-left="printer" @click="print">印刷</b-button>
                </div>
              </section>
              <section class="printTarget">
                <div id="item-contens">
                  <div class="card-content margin-top printMargin">
                    <table>
                      <tr><th>受付日時</th><td>{{requestDate}}</td></tr>
                      <tr><th>受付番号</th><td>{{receiptNumber}}</td></tr>
                    </table>
                  </div>
                </div>
                <cpapRequestDetail :data="showDetailTargetData"/>
              </section>
            </b-step-item>
          </b-steps>
        </div>
        </form>
      </div>
    </section>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <organizationSelectModal v-if="isSalesOffice || isHonsha || isAdmin" :selectRole="[role.role_hospital]" :selectStatus="extUserStatus.registed" title="医療機関選択" labelForOrg="医療機関名" @select="setOrganization"></organizationSelectModal>
      <facilitySelectModal v-if="isDealer" :dealerId="userId" @select="setfacility"></facilitySelectModal>
    </b-modal>
    <b-modal :active.sync="officeCalenderActive" has-modal-card>
      <officeCalenderModal :miniday="miniday" :maxDay="maxday" :disabledDays="disabledDays" @select="setShippingDate" @change-page="changePage"></officeCalenderModal>
    </b-modal>
  </div>
</template>
<script>
const sampleData = require('@/sampledata/CpapInstrumentDetail.json')

import {role} from "@/components/mock/base/const.js";
import {
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder
} from "@/components/mock/base/const.js";
import {consentStatement} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import {extUserStatus} from "@/components/mock/base/const.js";
import {LendingPeriod} from "@/components/mock/base/const.js";
import CpapRequestDetail from "@/components/mock/common/CpapInstrumentRequestDetail";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";
import FacilitySelectModal from "@/components/mock/philips/common/FacilitySelectModal";
import OfficeCalenderModal from "@/components/mock/guest/OfficeCalenderModal";

export default {
  name: "CpapInstrumentRequest",
  methods: {
    Backward: function() {
      this.activeStep -= 1;
    },
    Forward: function(event) {
      // バリデーションチェック
      var stepItems = document.getElementsByClassName("step-item")
      var target
      for(var item of stepItems){
        if(item.getAttribute("style") != "display: none;"){
          target = item
        }
      }
      var activeStep = target ? target.getAttribute("step") : ""
      if(activeStep){
        var elements = document.getElementsByClassName(activeStep)
        var result = this.selfMadeValidation(elements)
        if(result.isError){
          this.showErrorMessage(result.msg)
        }else{
          // 再レンダリングの為、フラグ切替
          this.renderKey = !this.renderKey
          this.activeStep += 1;
        }
      }
    },
    requestHst: function() {
      var model = this.modelList.find(val => val.value == this.reqParams.model)
      var messsage = model.label1
      messsage += "の預託機を申込みます。<br/>機種が正しいことを確認して「OK」ボタンを押してください。<br/><span style=\"font-size: 14px;\">※申込み後のキャンセルは申請一覧の受付番号の右端のメールボタンから問い合わせをお願いします。機器が出荷された後のキャンセルは不可となり、請求が発生しますのでご注意ください</span>"
      this.$dialog.confirm({
        title: "申込み確認",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async () => {
          this.compleateFlg = true;
          //var excuteApi = this.setHstApplicationPOST;
          //var successCallBack = this.setHstApplicationPOSTSuccess;
          //var errorCallBack = this.setHstApplicationPOSTError;
          // WebAPI Call
          //await this.apiCall(excuteApi, successCallBack, errorCallBack)
          if(this.compleateFlg){
            // モック用データ設定
            var now = new Date()
            var ret = "yyyy/MM/dd HH:mm:ss"
            ret = ret.replace(/yyyy/g, ('000' + now.getFullYear()).slice(-4))
            ret = ret.replace(/MM/g, ('0' + (now.getMonth() + 1)).slice(-2))
            ret = ret.replace(/dd/g, ('0' + now.getDate()).slice(-2))
            ret = ret.replace(/HH/g, ('0' + now.getHours()).slice(-2))
            ret = ret.replace(/mm/g, ('0' + now.getMinutes()).slice(-2))
            ret = ret.replace(/ss/g, ('0' + now.getSeconds()).slice(-2))
            this.requestDate = ret
            this.receiptNumber = "0000236-0001"

            this.jumpToTop();
            this.activeStep += 1;
          }
        }
      });
    },
    back: function() {
      this.$router.go(-1);
    },
    goHome: function() {
      this.back();
    },
    addPatient: function() {
      this.reqParams.patientsData.push({
          patientId:"",
          patientFamilyName:"",
          patientFirstName:"",
          patientFamilyNameKana:"",
          patientFirstNameKana:"",
          gender:"-",
          birthday:"",
          age:"",
        });
      
      //this.reqParams.shippingDate = ""
      //this.reqParams.returnDate = ""
    },
    changeModel: async function() {
      var _this = this
      //_this.reqParams.shippingDate = ""
      //_this.reqParams.returnDate = ""
      
      //最短出荷日の変更
      //●ePatch：翌営業日まで選択できない　　（申込時点から2営業日目は選択可能）
      await this.getBusinessDayPOST(null, 2, function(result) {
        _this.miniday = new Date(result.obj.date)
      })
    },
    setShippingDate: function(selectDate){
      this.reqParams.shippingDate = selectDate
      this.shippingDateInput();
      this.officeCalenderActive = false;
    },
    changePage: function(sDate, eDate) {
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalShipmentCalendar.getStockCalendarPOST({
            body: {
              startDate: sDate,
              modelId: _this.reqParams.model
            }
          });
        },
        function(result){
          var disabled = result.obj.filter(data => {
            return data.stock < _this.reqParams.patientsData.length
          })
          _this.disabledDays = disabled
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    shippingDateInput: function() {
      // 返却日 = 出荷日+3週間(21日)
      var workDate = new Date(this.reqParams.shippingDate);
      workDate = this.getBusinessDay(workDate, this.lendingPeriod);
      this.reqParams.returnDate = this.yyyy_sla_MM_sla_dd(workDate);
    },
    setOrganization: function(organizationInfo){
      this.reqParams.belongsId = organizationInfo.id + "";
      this.reqParams.hospitalName = organizationInfo.orgName;

      this.reqParams.receiverName = organizationInfo.orgName;
      this.reqParams.resultReceiverName = organizationInfo.orgName;

      this.reqParams.zip = organizationInfo.zip;
      this.reqParams.address = organizationInfo.prefecture + organizationInfo.city;
      this.reqParams.address1 = organizationInfo.address;
      this.reqParams.address2 = organizationInfo.building ? organizationInfo.building : "";
      this.reqParams.phoneNumber = organizationInfo.phoneNumber;

      this.reqParams.resultZip = organizationInfo.zip;
      this.reqParams.resultAddress = organizationInfo.prefecture + organizationInfo.city + organizationInfo.address;
      this.reqParams.resultBuildingName = organizationInfo.building ? organizationInfo.building : "";
      this.reqParams.resultPhoneNumber = organizationInfo.phoneNumber;
      
      if (!this.belongsId || this.belongsId != organizationInfo.id) {
        // 代理申込時
        this.belongsId = organizationInfo.id
      }
      // 前回申込み情報の取得
      this.prevHstSearchParam.belongsId = this.belongsId
      this.getPreviousApplication()
    },
    setfacility:  function(facility){
      this.reqParams.institutionId = facility.id + "";
      this.reqParams.hospitalName = facility.orgName;

      this.reqParams.receiverName = facility.orgName;
      this.reqParams.resultReceiverName = facility.orgName;

      this.reqParams.zip = facility.postcode;
      this.reqParams.address = facility.prefecture + facility.address;
      this.reqParams.address1 = facility.houseNumber;
      this.reqParams.address2 = facility.building ? facility.building : "";

      // 前回申込み情報の取得
      this.prevHstSearchParam.institutionId = facility.id
      this.getPreviousApplication()
    },
    print: function(){
      window.print();
    },
    inputBirthday: function(birthday,index){
      var age = this.getAge(birthday)
      if(!isNaN(Number(age))){
        this.reqParams.patientsData[index].age = age < 0 ? 0 : age

        const date = new Date(birthday);
        const options = {era: 'long'};
        this.reqParams.patientsData[index].japaneseCalendar = "【"+this.getJapaneseCalendar(date)+"】"
      }else{
        this.reqParams.patientsData[index].age = ""
      }
    },
    setHstApplicationPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.reqParams));
      obj.shortestShippingDate = this.yyyy_sla_MM_sla_dd(this.miniday)
      obj.shippingDate = obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      obj.clientDate = new Date().toString();

      if (!obj.mailNotification) {
        obj.hospitalMail = ""
      }
      for(const patient of obj.patientsData){
        patient.age = patient.age + ""
        patient.birthday = patient.birthday ? patient.birthday.replace(/-/g, "/") :""
      }
      obj.belongsId = this.belongsId
      return client.apis.externalHst.setHstApplicationPOST({
        body:obj
      });
    },
    setHstApplicationPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.requestDate = result.obj.requestDate
      this.receiptNumber = result.obj.receiptNumber
      this.compleateFlg = true;
    },
    setHstApplicationPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    addressSearch: function(target,val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return; 
        if(target!="result"){
          this.reqParams.address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.reqParams.address1 = ""
          this.reqParams.address2 = ""
        }else{
          this.reqParams.resultAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.reqParams.resultBuildingName = ""
        }
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.searchTargetPostCode = ""
    },
    getAgreementStr: async function() {
      var excuteApi = this.getConsentStatementPOST;
      var successCallBack = this.getConsentStatementPOSTSuccess;
      var errorCallBack = this.getConsentStatementPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getConsentStatementPOST: function(client) {
      var type = this.consentStatement.holter_hospital;
      if(this.isDealer){
        type = this.consentStatement.holter_dealer;
      }
      return client.apis.apiCommon.getConsentStatementPOST({
        body: {
          type: type
        } 
      });
    },
    getConsentStatementPOSTSuccess: function(result) {
      if(result.body.contents != ""){
        this.agreement = result.body.contents;
        this.canAgree = true;
      } else {
        this.agreement = "利用規約が登録されていません。";
      }
    },
    getConsentStatementPOSTError: function(result) {
      this.agreement == "利用規約を取得できませんでした。";
    },    
    getChoicesList: async function() {
      this.modelList = this.getChoiceList(this.choicesType.cpapKind, false);

      this.modelList.unshift({})
    },
    getPreviousApplication: async function() {
      var excuteApi = this.getPreviousApplicationDetailsPOST;
      var successCallBack = this.getPreviousApplicationDetailsPOSTSuccess;
      var errorCallBack = this.getPreviousApplicationDetailsPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPreviousApplicationDetailsPOST: function(client) {
      return client.apis.apiCommon.getPreviousApplicationDetailsPOST({
        body: this.prevHstSearchParam
      });
    },
    getPreviousApplicationDetailsPOSTSuccess: function(result) {
      this.reqParams.doctorName = result.body.doctorName
      // TODO モック用 delete
      //this.reqParams.model = result.body.modelId
      this.changeModel()
    },
    getPreviousApplicationDetailsPOSTError: function(result) {
      // 取得失敗時
    },
    focusLostPatientFirstName: function(index) {
      if(!this.reqParams.patientsData[index].receiverName || this.reqParams.patientsData[index].receiverName==""){
        this.reqParams.patientsData[index].receiverName = this.reqParams.patientsData[index].patientFamilyName + " " + this.reqParams.patientsData[index].patientFirstName
        // 再レンダリングの為、フラグ切替
        this.renderKey = !this.renderKey
      }
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var miniday = new Date()
    var maxDate = new Date()
    maxDate.setDate(maxDate.getDate() + 365);
    var maxday = new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
    var isDealer = roleId == role.role_dealer;
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHospital = roleId == role.role_hospital;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;
    return {
      showDetailTargetData: sampleData,
      role: role,
      roleId: roleId,
      userId: userId,
      choicesType:choicesType,
      extUserStatus: extUserStatus,
      belongsId:userInfo.belongsId,
      lendingPeriod:LendingPeriod.period,
      organizationModalActive: false,
      isChecked: false,
      agreement: "",
      activeStep: 0,
      isHospitalAgree: roleId != role.role_dealer,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      miniday: miniday,
      maxday:maxday,
      disabledDays: [],
      reqParams: {
        isDealer: isDealer,
        hospitalName: isHospital ? userInfo.medicalInstitutionName + " " + userInfo.departmentName : "",
        doctorName: "",
        clerkName:"",
        mailNotification:false,
        hospitalMail:"",
        zip:isHospital ? userInfo.postcode : "",
        address:isHospital ? userInfo.prefecture + " " + userInfo.city : "",
        address1:isHospital ? userInfo.address : "",
        address2:isHospital ? userInfo.building : "",
        // TODO mock用初期データ start
        //receiverName:"",             
        receiverName:isHospital ? userInfo.medicalInstitutionName + " " + userInfo.departmentName : "",
        // TODO mock用初期データ end
        phoneNumber:isHospital ? userInfo.phoneNumber : "",
        desiredDeliveryTimeZone:"",
        resultZip:"",
        resultAddress:"",
        resultBuildingName:"",
        resultCompanyName:"",
        resultDivision:"",
        resultReceiverName:"",
        resultPhoneNumber:"",
        // TODO mock用初期データ start
        //model:"",
        model:"8",
        // TODO mock用初期データ end
        delivaryTarget:"hospital",
        demo:false,
        returnDate:"",
        shippingDate:null,
        deliverySlip:false,
        institutionId: "",
        serialNumber:"",
        patientsData: [{
          patientId:"",
          patientFamilyName:"",
          patientFirstName:"",
          patientFamilyNameKana:"",
          patientFirstNameKana:"",
          gender:"-",
          birthday:"",
          age:"",
          japaneseCalendar:"",
          disease:"",
          infectionName: "",
          hospitalName: "",
          doctorName: "",
          // for single byte numeric validation
          invalidPostcode: false,
          invalidPhoneNumber: false,

          // TODO mock用初期データ start
          patientId:"0199",
          patientFamilyName:"患者",
          patientFirstName:"太郎",
          patientFamilyNameKana:"カンジャ",
          patientFirstNameKana:"タロウ",
          hospitalName: isHospital ? userInfo.medicalInstitutionName + " " + userInfo.departmentName : "",
          zip: "1234567",
          address:"東京都 港区お台場",
          address1:"１丁目99-9",
          receiverName:"患者 太郎",
          phoneNumber:"039999999",
          disease:"睡眠時無呼吸症候群",
          // TODO mock用初期データ end
        }],
        judgmentFlag:false,
        isRequest: true,
      },
      compleateFlg:false,
      searchTargetPostCode:"",
      searchTargetAddress:null,
      requestDate:"",
      receiptNumber:"",
      renderKey:true,
      officeCalenderActive: false,
      needAgree: roleId == role.role_hospital || roleId == role.role_dealer,
      canAgree:false,
      consentStatement:consentStatement,
      modelList:[],
      desiredDeliveryTimeZoneList:[],
      cannulaSizeList:[],
      beltSizeList:[],
      attachedWaveformList:[],
      prevHstSearchParam:{
        kind:"holter",
        belongsId:userInfo.belongsId,
        institutionId:0,
        fullFlag:false
      },
      isHospital,
      inspectionPurposeList:[],
      // for single byte numeric validation
      invalidDeviceDestPostcode: false,
      invalidDeviceDestPhoneNumber: false,
      invalidResultDestPostcode: false,
      invalidResultDestPhoneNumber: false,
      // template message
      invalidNumberMessage,
      postcodePlaceholder,
      phonePlaceholder,
    };
  },
  computed: {},
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    organizationSelectModal:OrganizationSelectModal,
    facilitySelectModal:FacilitySelectModal,
    cpapRequestDetail:CpapRequestDetail,
    officeCalenderModal:OfficeCalenderModal
  },
  async mounted() {
    //同意文取得
    await this.getAgreementStr();
    // マスタ取得
    await this.getChoicesList();

    if(this.isHospital){
      // 前回申込み情報の取得
      this.getPreviousApplication()
    }
  },
  watch: {
    "reqParams.zip"(newValue) {
      this.invalidDeviceDestPostcode = isNaN(Number(newValue));
    },
    "reqParams.phoneNumber"(newValue) {
      this.invalidDeviceDestPhoneNumber = isNaN(Number(newValue));
    },
    "reqParams.resultZip"(newValue) {
      this.invalidResultDestPostcode = isNaN(Number(newValue));
    },
    "reqParams.resultPhoneNumber"(newValue) {
      this.invalidResultDestPhoneNumber = isNaN(Number(newValue));
    },
    "reqParams.patientsData": {
      handler(newValue) {
        for(var i = 0; i < newValue.length; i++) {
          newValue[i].invalidPostcode = isNaN(Number(newValue[i].zip));
          newValue[i].invalidPhoneNumber = isNaN(Number(newValue[i].phoneNumber));
        }
      },
      deep: true,
    },
  }
};
</script>

<style>
</style>
<style lang="scss" scoped>
.shippingDate {
  width: 150px  !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapInstrumentRequest.vue